import { UI, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { IInvestedAssetsNormalized } from '../../../../../../../../../store/customerDetail/types';

export interface ProductTabletCardProps {
  product: IInvestedAssetsNormalized;
  index: number;
  children?: React.ReactNode;
}

export const ProductTabletCard: React.FC<ProductTabletCardProps> = ({
  index,
  product,
  children,
}) => {
  return (
    <UI.Shadow testId="shadow" level={1} borderRadius="8px" key={index.toString()}>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        bottom={0}
        w={'4px'}
        backgroundColor={Color[product.colorNormalized]}
        borderTopLeftRadius={'full'}
        borderBottomLeftRadius={'full'}
      />
      <VStack p={Spacing['inset.xs']} space={Spacing['inset.xs']}>
        {children}
      </VStack>
    </UI.Shadow>
  );
};
